var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
const VideoContainer = styled.div `
  position: relative;
  overflow: hidden;
  z-index: 2;
`;
const VideoWrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  aspect-ratio: 16 / 9;

  @supports not (aspect-ratio: 16 / 9) {
    // see: http://alistapart.com/article/creating-intrinsic-ratios-for-video
    // create a 16:9 ratio -> 16/9 = 0.5625
    // padding in percentage is based on width of element
    // setting padding bottom to 56.25% will set the container height to match the 16/9 ratio
    padding-bottom: 56.25%;
    height: 100%;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
const Video = (_a) => {
    var { video: { vimeoId }, children } = _a, props = __rest(_a, ["video", "children"]);
    return (React.createElement(VideoContainer, Object.assign({}, props),
        React.createElement(VideoWrapper, { className: "video-container" },
            React.createElement("iframe", { className: "video", src: `https://player.vimeo.com/video/${vimeoId}?fullscreen=1`, width: "640", height: "360", frameBorder: "0", allow: "fullscreen", allowFullScreen: true })),
        children));
};
export default Video;
